module.exports = __webpack_public_path__ + "media/components/alert-table/static/icon-delete-037d8c2311061c6e40df2ec14496bf5b.svg";